import { useEffect, useState } from "react";
import { AuthenticationApiCalls } from "../../../../apis/AuthenticationApiCalls";
import { InstitutionApiCalls } from "../../../../apis/InstitutionApiCalls";
import OverrideModal from "../../../../components/modals/OverrideModal";
import TestApiModal from "../../../../components/modals/TestApiModal";
import YuJaButton from "../../../../components/standardization/YuJaButton";
import { YuJaDropdown } from "../../../../components/standardization/YuJaDropdown";
import { YuJaTextBox } from "../../../../components/standardization/YuJaTextBox";
import apiAccessIcon from "../../../../images/apiAccessIcon.svg";
import linkageSettingsIcon from "../../../../images/linkageSettingsIcon.svg";
import { ReactComponent as CLOSE } from "../../../../images/Close.svg";
import {
    API_ACCESS,
    API_ENDPOINT_INST,
    BB_CARD_DESC,
    BB_COURSES,
    BB_USERS,
    CANVAS_CARD_DESC,
    CANVAS_COURSES,
    CANVAS_USERS,
    D2L_CARD_DESC,
    D2L_COURSES,
    D2L_USERS,
    FALL_BACK_TO_EMAIL_LMS_BB,
    FALL_BACK_TO_EMAIL_LMS_CANVAS,
    FALL_BACK_TO_EMAIL_LMS_D2L,
    FALL_BACK_TO_EMAIL_LMS_MOODLE,
    INTEGRATION_GUIDE,
    INTEGRATION_TYPES,
    INTEGRATION_TYPES_LOWERCASE,
    INTEG_TEXT_BOX,
    LINKAGE_SETTINGS,
    LMS_API_LINK,
    LMS_ACCESS_KEY_FIELDS,
    MODAL_CANCEL_TEXT,
    MOODLE_CARD_DESC,
    MOODLE_COURSES,
    MOODLE_USERS,
    OVERRIDE_TEXT,
    PRIMARY_LINKAGE_ATTR,
    DOMAIN,
    INST_BASE_URL, FALL_BACK_TO_EMAIL_LMS, MOODLE_PLUGIN_ZIP_FILE_NAME, AUTO_SYNC_USER,
    TEST_API_BUTTON_TEXT,
} from "../../../../utils/constants";
import { notifyError, notifySuccess } from "../../../../utils/helpers";
import { D2L_INVALID_COURSE_ID_ERROR, LMS_API_UNSAVED_CHANGES } from "../../../../utils/toast-message-constants";
import styles from "./LTI3.module.css";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {ReactComponent as DOWNLOAD_ICON} from "../../../../images/plugin_icon.svg";
import {useConfig} from "../../../../hooks/useConfig";
import {Button} from "@base-ui/react/button";
import YuJaSwitch from "../../../../components/standardization/YuJaSwitch";

export default function GeneralLMSAPIPage({ selectedMenu, canvasForm, blackboardForm, d2lForm, moodleForm, setD2lForm, setBlackboardForm, setCanvasForm, setMoodleForm, onLmsFormLoaded = () => {}, rawLmsForms = {} }) {
    const [loaded, setLoaded] = useState(false);
    const [syncCourseId, ] = useState("");
    const [openOverride, setOpenOverride] = useState(false);
    const [openTestApi, setOpenTestApi] = useState(false);
    const [, setAccessTokenElement] = useState(null);
    const { getSSODetails } = InstitutionApiCalls();
    const [loading , setLoading] = useState(false);
    const { getD2LAuthURL } = AuthenticationApiCalls();
    const config = useConfig();
    const [downloadLink, setDownloadLink] = useState("");

    const handleDownload = () => {
        if (downloadLink) {
            const link = document.createElement('a');
            link.href = downloadLink;
            link.download = MOODLE_PLUGIN_ZIP_FILE_NAME;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    useEffect(() => {
        const url = `${config.s3.public_access_url}/${MOODLE_PLUGIN_ZIP_FILE_NAME}`;
        const requestOptions = {method: "GET"};
        fetch(url, requestOptions).then((response) => {
            return response.blob();
        })
            .then((blob) => URL.createObjectURL(blob))
            .then((href) => {
                setDownloadLink(href);
            });
    }, []);



    const MOODLE_USER_LINKAGE_ATTRIBUTES = {
        MOODLE_USER_ID: { value: "userId", display: "Moodle User ID" },
        PRIMARY_EMAIL: { value: "email", display: "Primary Email" }
    }
    const CANVAS_USER_LINKAGE_ATTRIBUTES = {
        CANVAS_USER_ID: { value: "userId", display: "Canvas User ID" },
        PRIMARY_EMAIL: { value: "email", display: "Primary Email" }
    }
    const D2L_USER_LINKAGE_ATTRIBUTES = {
        D2L_USER_ID: { value: "userId", display: "D2L User ID" },
        PRIMARY_EMAIL: { value: "email", display: "Primary Email" }
    }
    const BB_USER_LINKAGE_ATTRIBUTES = {
        BB_USER_ID: { value: "userId", display: "BB User ID" },
        PRIMARY_EMAIL: { value: "email", display: "Primary Email" }
    }
    const MOODLE_COURSE_LINKAGE_ATTRIBUTES = {
        MOODLE_COURSE_ID: { value: "courseId", display: "Moodle Course ID" },
    }
    const CANVAS_COURSE_LINKAGE_ATTRIBUTES = {
        CANVAS_COURSE_ID: { value: "courseId", display: "Canvas Course ID" },
    }
    const D2L_COURSE_LINKAGE_ATTRIBUTES = {
        D2L_COURSE_ID: { value: "courseId", display: "D2L Course ID" },
    }
    const BB_COURSE_LINKAGE_ATTRIBUTES = {
        BB_COURSE_ID: { value: "courseId", display: "BB Course ID" },
    }
    const [selectedUserItem, setSelectedUserItem] = useState(MOODLE_USER_LINKAGE_ATTRIBUTES.MOODLE_USER_ID.value);
    const [selectedCourseItem, setSelectedCourseItem] = useState(MOODLE_COURSE_LINKAGE_ATTRIBUTES.MOODLE_COURSE_ID.value);
    const getIntegrationType = () => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) { return INTEGRATION_TYPES.MOODLE; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) { return INTEGRATION_TYPES.CANVAS; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) { return INTEGRATION_TYPES.D2L; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) { return INTEGRATION_TYPES.BLACKBOARD; }
    };
    const getSSOMap = (ssoMap) => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) { return ssoMap.MOODLE; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) { return ssoMap.CANVAS; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) { return ssoMap.D2L; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) { return ssoMap.BLACKBOARD; }
    };
    const getForm = () => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) { return moodleForm; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) { return canvasForm; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) { return d2lForm; }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) { return blackboardForm; }
    };
    const callUpdateFunction = (e) => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) { handleMoodleFormChange(e); }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) { handleCanvasFormChange(e); }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) { handleD2LFormChange(e); }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) { handleBBFormChange(e); }
    };


    const onSwitch = (name, checked) => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            const moodleFormCopy = Object.assign({}, moodleForm);
            moodleFormCopy[name] = checked;
            setMoodleForm(moodleFormCopy);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            const canvasFormCopy = Object.assign({}, canvasForm);
            canvasFormCopy[name] = checked;
            setCanvasForm(canvasFormCopy);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            const d2lFormCopy = Object.assign({}, d2lForm);
            d2lFormCopy[name] = checked;
            setD2lForm(d2lFormCopy);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            const blackboardFormCopy = Object.assign({}, blackboardForm);
            blackboardFormCopy[name] = checked;
            setBlackboardForm(blackboardFormCopy);
        }
    }

    const handleUserLinkageValueChange = (item) => {
        setSelectedUserItem(item.value);
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            const moodleFormConst = Object.assign({}, moodleForm);
            moodleFormConst["apiUserLinkageAttr"] = item.value;
            setMoodleForm(moodleFormConst);
        }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            const canvasFormConst = Object.assign({}, canvasForm);
            canvasFormConst["apiUserLinkageAttr"] = item.value;
            setCanvasForm(canvasFormConst);
        }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            const d2lFormConst = Object.assign({}, d2lForm);
            d2lFormConst["apiUserLinkageAttr"] = item.value;
            setD2lForm(d2lFormConst);
        }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            const bbFormConst = Object.assign({}, blackboardForm);
            bbFormConst["apiUserLinkageAttr"] = item.value;
            setBlackboardForm(bbFormConst);
        }
    };
    const handleCourseLinkageValueChange = (item) => {
        setSelectedCourseItem(item.value);
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            const moodleFormConst = Object.assign({}, moodleForm);
            moodleFormConst["apiCourseLinkageAttr"] = item.value;
            setMoodleForm(moodleFormConst);
        }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            const canvasFormConst = Object.assign({}, canvasForm);
            canvasFormConst["apiCourseLinkageAttr"] = item.value;
            setCanvasForm(canvasFormConst);
        }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            const d2lFormConst = Object.assign({}, d2lForm);
            d2lFormConst["apiCourseLinkageAttr"] = item.value;
            setD2lForm(d2lFormConst);
        }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            const bbFormConst = Object.assign({}, blackboardForm);
            bbFormConst["apiCourseLinkageAttr"] = item.value;
            setBlackboardForm(bbFormConst);
        }
    };
    const handleMoodleFormChange = (e) => {
        const input = e.currentTarget;
        const moodleFormConst = Object.assign({}, moodleForm);
        if (input.type === "checkbox") {
            moodleFormConst[input.name] = input.checked;
        } else {
            moodleFormConst[input.name] = input.value;
        }
        setMoodleForm(moodleFormConst);
    };
    const handleCanvasFormChange = (e) => {
        const input = e.currentTarget;
        const canvasFormConst = Object.assign({}, canvasForm);
        if (input.type === "checkbox") {
            canvasFormConst[input.name] = input.checked;
        } else {
            canvasFormConst[input.name] = input.value;
        }
        setCanvasForm(canvasFormConst);
    };
    const handleD2LFormChange = (e) => {
        const input = e.currentTarget;
        const d2lFormConst = Object.assign({}, d2lForm);
        if (input.type === "checkbox") {
            d2lFormConst[input.name] = input.checked;
        } else {
            d2lFormConst[input.name] = input.value;
        }
        setD2lForm(d2lFormConst);
    };
    const handleBBFormChange = (e) => {
        const input = e.currentTarget;
        const bbFormConst = Object.assign({}, blackboardForm);
        if (input.type === "checkbox") {
            bbFormConst[input.name] = input.checked;
        } else {
            bbFormConst[input.name] = input.value;
        }
        setBlackboardForm(bbFormConst);
    };
    const d2lAllowApiAccess = () => {
        if (d2lForm.domain !== "" && d2lForm.lmsApiLink !== "") {
            getD2LAuthURL();
        } else {
            notifyError(D2L_INVALID_COURSE_ID_ERROR);
        }
    };
    const fetchData = () => {
        setLoading(true);
        getSSODetails().then((result) => {
          let ssoMap = result.ssoConfig;
          const ssoConfigData = JSON.parse(
            ssoMap.hasOwnProperty(getIntegrationType())
              ? getSSOMap(ssoMap)
              : "{}"
          );
          if (
            ssoConfigData !== "undefined" ||
            ssoConfigData.propertyIsEnumerable()
          ) {
            if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
                if(ssoConfigData.apiCourseLinkageAttr === undefined || ssoConfigData.apiCourseLinkageAttr === "") {
                    ssoConfigData.apiCourseLinkageAttr = MOODLE_COURSE_LINKAGE_ATTRIBUTES.MOODLE_COURSE_ID.value;
                }
                setSelectedCourseItem(ssoConfigData.apiCourseLinkageAttr);
                if(ssoConfigData.apiUserLinkageAttr === undefined || ssoConfigData.apiUserLinkageAttr === "") {
                    ssoConfigData.apiUserLinkageAttr = MOODLE_USER_LINKAGE_ATTRIBUTES.MOODLE_USER_ID.value;
                }
                setSelectedUserItem(ssoConfigData.apiUserLinkageAttr);
                setMoodleForm(ssoConfigData);
                onLmsFormLoaded(INTEGRATION_TYPES.MOODLE, ssoConfigData);
            }
            if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
                if(ssoConfigData.apiCourseLinkageAttr === undefined || ssoConfigData.apiCourseLinkageAttr === "") {
                    ssoConfigData.apiCourseLinkageAttr = CANVAS_COURSE_LINKAGE_ATTRIBUTES.CANVAS_COURSE_ID.value;
                }
                setSelectedCourseItem(ssoConfigData.apiCourseLinkageAttr);
                if(ssoConfigData.apiUserLinkageAttr === undefined || ssoConfigData.apiUserLinkageAttr === "") {
                    ssoConfigData.apiUserLinkageAttr = CANVAS_USER_LINKAGE_ATTRIBUTES.CANVAS_USER_ID.value;
                }
                setSelectedUserItem(ssoConfigData.apiUserLinkageAttr);
                setCanvasForm(ssoConfigData);
                onLmsFormLoaded(INTEGRATION_TYPES.CANVAS, ssoConfigData);
            }
            if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
                if(ssoConfigData.apiCourseLinkageAttr === undefined || ssoConfigData.apiCourseLinkageAttr === "") {
                    ssoConfigData.apiCourseLinkageAttr = D2L_COURSE_LINKAGE_ATTRIBUTES.D2L_COURSE_ID.value;
                }
                setSelectedCourseItem(ssoConfigData.apiCourseLinkageAttr);
                if(ssoConfigData.apiUserLinkageAttr === undefined || ssoConfigData.apiUserLinkageAttr === "") {
                    ssoConfigData.apiUserLinkageAttr = D2L_USER_LINKAGE_ATTRIBUTES.D2L_USER_ID.value;
                }
                setSelectedUserItem(ssoConfigData.apiUserLinkageAttr);
                setD2lForm(ssoConfigData);
                onLmsFormLoaded(INTEGRATION_TYPES.D2L, ssoConfigData);
            }
            if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
                if(ssoConfigData.apiCourseLinkageAttr === undefined || ssoConfigData.apiCourseLinkageAttr === "") {
                    ssoConfigData.apiCourseLinkageAttr = BB_COURSE_LINKAGE_ATTRIBUTES.BB_COURSE_ID.value;
                }
                setSelectedCourseItem(ssoConfigData.apiCourseLinkageAttr);
                if(ssoConfigData.apiUserLinkageAttr === undefined || ssoConfigData.apiUserLinkageAttr === "") {
                    ssoConfigData.apiUserLinkageAttr = BB_USER_LINKAGE_ATTRIBUTES.BB_USER_ID.value;
                }
                setSelectedUserItem(ssoConfigData.apiUserLinkageAttr);
                setBlackboardForm(ssoConfigData);
                onLmsFormLoaded(INTEGRATION_TYPES.BLACKBOARD, ssoConfigData);
            }
          }
        setLoading(false);
        });
      };

    const modalConfig = {
        title: INTEGRATION_GUIDE.COMMON.addAccessKeyButtonText,
        okText: OVERRIDE_TEXT,
        cancelText: MODAL_CANCEL_TEXT,
        desc: INTEGRATION_GUIDE.COMMON.addAccessKeyModalDescription,
        okDisabled: true,
        initialValues: {
            field1:
                selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS ? (canvasForm.apiAccessKeyClientId || "") :
                selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L ? (d2lForm.appId || "") :
                selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD ? (blackboardForm.appKey || "") :
                "",
        },
        submit: async (e, field2) => {
            if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
                const moodleFormConst = Object.assign({}, moodleForm);
                moodleFormConst["apiAccessToken"] = e;
                setMoodleForm(moodleFormConst);
            } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
                setD2lForm({
                    ...d2lForm,
                    appId: e,
                    appKey: field2,
                });
            } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
                setBlackboardForm({
                    ...blackboardForm,
                    appKey: e,
                    appSecret: field2,
                });
            } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
                setCanvasForm({
                    ...canvasForm,
                    apiAccessKeyClientId: e,
                    apiAccessKeyClientSecret: field2,
                });
            }
            setOpenOverride(false);
            notifySuccess(LMS_API_UNSAVED_CHANGES);
        },
        close:  async () => {
          setOpenOverride(false);
        },
    };

    const openOverrideModal = () => {
        setOpenOverride(true);
    };

    const openTestApiModal = () => {
        setOpenTestApi(true);
    };

    const isAccessKeyUnsaved = () => {
        const rawForm = rawLmsForms[getIntegrationType()];
        if (!rawForm) {
            return false;
        }
        const fields = LMS_ACCESS_KEY_FIELDS[selectedMenu] || [];
        const form = getForm();
        return fields.some(f => (rawForm[f] || "") !== (form[f] || ""));
    };

    const isAccessKeyConfigured = () => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            return !!moodleForm.apiAccessToken;
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            return !!canvasForm.apiAccessKeyClientId && !!canvasForm.apiAccessKeyClientSecret;
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            return !!d2lForm.appId && !!d2lForm.appKey;
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            return !!blackboardForm.appKey && !!blackboardForm.appSecret;
        }
        return false;
    };

    const clearAccessKey = () => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            setMoodleForm({...moodleForm, apiAccessToken: ""});
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            setCanvasForm({...canvasForm, apiAccessKeyClientId: "", apiAccessKeyClientSecret: ""});
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            setD2lForm({...d2lForm, appId: "", appKey: ""});
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            setBlackboardForm({...blackboardForm, appKey: "", appSecret: ""});
        }
    };

    useEffect(() => {
        fetchData();
        setLoaded(true);
        if(document.getElementById("lmsApiLastElem") != null) {
            document.getElementById("lmsApiLastElem").addEventListener('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey && document.getElementById("integrationSaveBtn")) {
                  e.preventDefault();
                  document.getElementById('integrationSaveBtn').focus();
                }
            });
        }
    }, [loaded, selectedMenu]);

    const onClickLink = () => {
        window.open(INTEGRATION_GUIDE.MOODLE.plugin.guideUrl);
    }

    return (<div>
        <div style={{display: "flex", flexDirection: "row", gap: 20, flexWrap: "wrap", marginTop: 20}}>
            <div style={{flex: 1, minWidth: 500, display: "flex", flexDirection: "column", gap: 20}}>
                {selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE &&
                    <div className={styles.cardBox} >
                        <div className={styles.cardBoxHeader}>
                            <DOWNLOAD_ICON style={{width: 24, height: 24}}/>
                            <span className={styles.cardHeader}>{INTEGRATION_GUIDE.MOODLE.plugin.title}</span>
                        </div>
                        <div className={styles.cardBoxBody}>
                            <div className={styles.cardDescription}>
                                {INTEGRATION_GUIDE.MOODLE.plugin.downloadDescription}
                            </div>



                                <div >
                                    {INTEGRATION_GUIDE.MOODLE.plugin.installedDescription}
                                    <Button className={styles.link} style={{marginLeft: 3}} onClick={onClickLink}>
                                        {INTEGRATION_GUIDE.MOODLE.plugin.installLinkText}
                                    </Button>
                                    {"."}

                                </div>


                            <YuJaButton onClick={handleDownload} >{INTEGRATION_GUIDE.MOODLE.plugin.downloadButtonText}</YuJaButton>
                        </div>
                    </div>
                }

                <div className={styles.cardBox}>
                    <div className={styles.cardBoxHeader}>
                        <img src={apiAccessIcon} alt={API_ACCESS} width={"24px"} height={"24px"} />
                        <span className={styles.cardHeader}>{API_ACCESS}</span>
                    </div>
                    <div className={styles.cardBoxBody}>
                        {!loading && INTEGRATION_GUIDE[getIntegrationType()] &&
                            <div className={styles.cardDescription}>
                                {INTEGRATION_GUIDE[getIntegrationType()].apiAccessGuide.description}{" "}
                                <a
                                    href={INTEGRATION_GUIDE[getIntegrationType()].apiAccessGuide.linkUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.link}
                                >
                                    {INTEGRATION_GUIDE[getIntegrationType()].apiAccessGuide.linkText}
                                </a>
                                {"."}
                            </div>
                        }
                        {!loading && selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L &&
                            <div className={styles.settingRow}>
                                <div style={{width: 250}}>
                                    <div className={styles.settingLabel}>{DOMAIN}</div>
                                    <div className={styles.settingDescription}>{INTEGRATION_GUIDE.COMMON.lmsApiLinkDescription}</div>
                                </div>
                                <YuJaTextBox
                                    label={DOMAIN + INTEG_TEXT_BOX}
                                    placeholder={INST_BASE_URL}
                                    name="domain"
                                    value={getForm().domain}
                                    containerStyle={{ fontSize: 14, lineHeight: 1.6,flex: 1, minWidth: 230 }}
                                    onChange={callUpdateFunction}
                                />
                            </div>
                        }

                        {!loading && selectedMenu !== INTEGRATION_TYPES_LOWERCASE.D2L &&
                        <div className={styles.settingRow}>
                            <div style={{width: 250}}>
                                <div className={styles.settingLabel}>{LMS_API_LINK}</div>
                                <div className={styles.settingDescription}>{INTEGRATION_GUIDE.COMMON.lmsApiLinkDescription}</div>
                            </div>
                            <YuJaTextBox
                                label={LMS_API_LINK + INTEG_TEXT_BOX}
                                placeholder={API_ENDPOINT_INST}
                                name="lmsApiLink"
                                value={getForm().lmsApiLink}
                                containerStyle={{ fontSize: 14, lineHeight: 1.6, flex: 1, minWidth: 230}}
                                onChange={callUpdateFunction}
                            />
                        </div>
                        }
                        {loading &&

                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                            </SkeletonTheme>
                        }

                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE && !loading &&
                            <div className={styles.settingColumn}>
                                <div>
                                    <div className={styles.settingLabel}>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</div>
                                    <div
                                        className={styles.settingDescription}>{INTEGRATION_GUIDE.COMMON.accessKeyDescription}</div>
                                </div>
                                {isAccessKeyConfigured()
                                    ? <div className={styles.accessKeyRow}>
                                        <span>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</span>
                                        <YuJaButton onClick={openOverrideModal}>{OVERRIDE_TEXT}</YuJaButton>
                                        {!isAccessKeyUnsaved() &&
                                            <YuJaButton onClick={openTestApiModal}>{TEST_API_BUTTON_TEXT}</YuJaButton>
                                        }
                                        <YuJaButton iconOnly onClick={clearAccessKey}>
                                            <CLOSE className={styles.accessKeyRemoveIcon}/>
                                        </YuJaButton>
                                        
                                    </div>
                                    : <YuJaButton onClick={openOverrideModal}>{INTEGRATION_GUIDE.COMMON.addAccessKeyButtonText}</YuJaButton>
                                }
                            </div>
                        }

                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE && loading &&

                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                            </SkeletonTheme>
                        }

                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS && !loading &&
                            <div className={styles.settingColumn}>
                                <div>
                                    <div className={styles.settingLabel}>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</div>
                                    <div
                                        className={styles.settingDescription}>{INTEGRATION_GUIDE.COMMON.accessKeyDescription}</div>
                                </div>
                                {isAccessKeyConfigured()
                                    ? <div className={styles.accessKeyRow}>
                                        <span>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</span>
                                        <YuJaButton onClick={openOverrideModal}>{OVERRIDE_TEXT}</YuJaButton>
                                        {!isAccessKeyUnsaved() &&
                                            <YuJaButton onClick={openTestApiModal}>{TEST_API_BUTTON_TEXT}</YuJaButton>
                                        }
                                        <YuJaButton iconOnly onClick={clearAccessKey}>
                                            <CLOSE className={styles.accessKeyRemoveIcon}/>
                                        </YuJaButton>
                                        
                                    </div>
                                    : <YuJaButton onClick={openOverrideModal}>{INTEGRATION_GUIDE.COMMON.addAccessKeyButtonText}</YuJaButton>
                                }
                            </div>
                        }

                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS && loading &&

                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey" >
                                <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                            </SkeletonTheme>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L && !loading &&
                            <div className={styles.settingColumn}>
                                <div>
                                    <div className={styles.settingLabel}>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</div>
                                    <div
                                        className={styles.settingDescription}>{INTEGRATION_GUIDE.COMMON.accessKeyDescription}</div>
                                </div>

                                {isAccessKeyConfigured()
                                    ? <div className={styles.accessKeyRow}>
                                        <span>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</span>
                                        <YuJaButton onClick={openOverrideModal}>{OVERRIDE_TEXT}</YuJaButton>
                                        {!isAccessKeyUnsaved() &&
                                            <YuJaButton onClick={openTestApiModal}>{TEST_API_BUTTON_TEXT}</YuJaButton>
                                        }
                                        <YuJaButton iconOnly onClick={clearAccessKey}>
                                            <CLOSE className={styles.accessKeyRemoveIcon}/>
                                        </YuJaButton>
                                        
                                    </div>
                                    : <YuJaButton onClick={openOverrideModal}>{INTEGRATION_GUIDE.COMMON.addAccessKeyButtonText}</YuJaButton>
                                }
                            </div>
                        }

                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L && loading &&

                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                                <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                            </SkeletonTheme>
                        }

                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD && !loading &&
                            <div className={styles.settingColumn}>
                                <div>
                                    <div className={styles.settingLabel}>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</div>
                                    <div
                                        className={styles.settingDescription}>{INTEGRATION_GUIDE.COMMON.accessKeyDescription}</div>
                                </div>
                                {isAccessKeyConfigured()
                                    ? <div className={styles.accessKeyRow}>
                                        <span>{INTEGRATION_GUIDE.COMMON.accessKeyLabel}</span>
                                        <YuJaButton onClick={openOverrideModal}>{OVERRIDE_TEXT}</YuJaButton>
                                        {!isAccessKeyUnsaved() &&
                                            <YuJaButton onClick={openTestApiModal}>{TEST_API_BUTTON_TEXT}</YuJaButton>
                                        }
                                        <YuJaButton iconOnly onClick={clearAccessKey}>
                                            <CLOSE className={styles.accessKeyRemoveIcon}/>
                                        </YuJaButton>
                                        
                                    </div>
                                    : <YuJaButton onClick={openOverrideModal}>{INTEGRATION_GUIDE.COMMON.addAccessKeyButtonText}</YuJaButton>
                                }
                            </div>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD && loading &&
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                                <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                            </SkeletonTheme>
                        }
                    </div>
                </div>
            </div>


            <div 
                className={styles.cardBox} 
                style={{flex: 1, minWidth: 500, height: selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE ? "fit-content" : undefined}}
            >
                <div className={styles.cardBoxHeader}>
                    <img src={linkageSettingsIcon} alt={LINKAGE_SETTINGS} width={"24px"} height={"24px"}/>
                    <span className={styles.cardHeader}>{LINKAGE_SETTINGS}</span>
                </div>
                <div className={styles.cardBoxBody}>
                    {selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE && !loading &&
                        <>
                            <div className={styles.cardDescription}>{MOODLE_CARD_DESC}</div>
                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{MOODLE_COURSES}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(MOODLE_COURSE_LINKAGE_ATTRIBUTES)}
                                        value={selectedCourseItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiCourseLinkageAttr"
                                        onChange={handleCourseLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{MOODLE_USERS}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(MOODLE_USER_LINKAGE_ATTRIBUTES)}
                                        value={selectedUserItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiUserLinkageAttr"
                                        onChange={handleUserLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{FALL_BACK_TO_EMAIL_LMS}</div>
                                    <div className={styles.settingDescription}>{FALL_BACK_TO_EMAIL_LMS_MOODLE}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaSwitch
                                        aria-label={FALL_BACK_TO_EMAIL_LMS}
                                        checked={getForm().fallbackToEmailLms}
                                        onChange={checked => onSwitch("fallbackToEmailLms", checked)}
                                    />
                                    {/*<YuJaToggle name="fallbackToEmailLms" toggled={getForm().fallbackToEmailLms}*/}
                                    {/*            onClick={callUpdateFunction}/>*/}
                                </div>
                            </div>
                        </>
                    }
                    {selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS && !loading &&
                        <>
                            <div className={styles.cardDescription}>{CANVAS_CARD_DESC}</div>
                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{CANVAS_COURSES}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(CANVAS_COURSE_LINKAGE_ATTRIBUTES)}
                                        value={selectedCourseItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiCourseLinkageAttr"
                                        onChange={handleCourseLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{CANVAS_USERS}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(CANVAS_USER_LINKAGE_ATTRIBUTES)}
                                        value={selectedUserItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiUserLinkageAttr"
                                        onChange={handleUserLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{FALL_BACK_TO_EMAIL_LMS}</div>
                                    <div className={styles.settingDescription}>{FALL_BACK_TO_EMAIL_LMS_CANVAS}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaSwitch
                                        aria-label={FALL_BACK_TO_EMAIL_LMS}
                                        checked={getForm().fallbackToEmailLms}
                                        onChange={checked => onSwitch("fallbackToEmailLms", checked)}
                                    />
                                    {/*<YuJaToggle name="fallbackToEmailLms" toggled={getForm().fallbackToEmailLms}*/}
                                    {/*            onClick={callUpdateFunction}/>*/}
                                </div>
                            </div>
                        </>
                    }
                    {selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L && !loading &&
                        <>
                            <div className={styles.cardDescription}>{D2L_CARD_DESC}</div>
                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{D2L_COURSES}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(D2L_COURSE_LINKAGE_ATTRIBUTES)}
                                        value={selectedCourseItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiCourseLinkageAttr"
                                        onChange={handleCourseLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{D2L_USERS}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(D2L_USER_LINKAGE_ATTRIBUTES)}
                                        value={selectedUserItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiUserLinkageAttr"
                                        onChange={handleUserLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{FALL_BACK_TO_EMAIL_LMS}</div>
                                    <div className={styles.settingDescription}>{FALL_BACK_TO_EMAIL_LMS_D2L}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaSwitch
                                        aria-label={FALL_BACK_TO_EMAIL_LMS}
                                        checked={getForm().fallbackToEmailLms}
                                        onChange={checked => onSwitch("fallbackToEmailLms", checked)}
                                    />
                                    {/*<YuJaToggle name="fallbackToEmailLms" toggled={getForm().fallbackToEmailLms}*/}
                                    {/*            onClick={callUpdateFunction}/>*/}
                                </div>
                            </div>
                        </>
                    }
                    {selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD && !loading &&
                        <>
                            <div className={styles.cardDescription}>{BB_CARD_DESC}</div>
                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{BB_COURSES}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(BB_COURSE_LINKAGE_ATTRIBUTES)}
                                        value={selectedCourseItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiCourseLinkageAttr"
                                        onChange={handleCourseLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{BB_USERS}</div>
                                    <div
                                        className={styles.settingDescription}>{PRIMARY_LINKAGE_ATTR}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaDropdown
                                        containerStyle={{width: 200}}
                                        data={Object.values(BB_USER_LINKAGE_ATTRIBUTES)}
                                        value={selectedUserItem}
                                        getOptionLabel={item => item.display}
                                        getOptionValue={item => item.value}
                                        name="apiUserLinkageAttr"
                                        onChange={handleUserLinkageValueChange}
                                    ></YuJaDropdown>
                                </div>
                            </div>

                            <div className={styles.settingRow}>
                                <div>
                                    <div className={styles.settingLabel}>{FALL_BACK_TO_EMAIL_LMS}</div>
                                    <div className={styles.settingDescription}>{FALL_BACK_TO_EMAIL_LMS_BB}</div>
                                </div>

                                <div style={{flex: 1, minWidth: 100, display: "flex", justifyContent: "end"}}>
                                    <YuJaSwitch
                                        aria-label={FALL_BACK_TO_EMAIL_LMS}
                                        checked={getForm().fallbackToEmailLms}
                                        onChange={checked => onSwitch("fallbackToEmailLms", checked)}
                                    />
                                    {/*<YuJaToggle name="fallbackToEmailLms" toggled={getForm().fallbackToEmailLms}*/}
                                    {/*            onClick={callUpdateFunction}/>*/}
                                </div>
                            </div>
                        </>
                    }

                    {loading &&

                        <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                            <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                            <Skeleton height={37} inline={true} borderRadius={10} style={{marginTop: 42}}/>
                        </SkeletonTheme>
                    }
                </div>
            </div>



            {openOverride &&
                <OverrideModal
                    show={openOverride}
                    setModalShow={setOpenOverride}
                    config={modalConfig}
                    lmsType={selectedMenu}
                    setAccessTokenElement={setAccessTokenElement}
                />
            }

            {openTestApi &&
                <TestApiModal
                    show={openTestApi}
                    onClose={() => setOpenTestApi(false)}
                    intType={getIntegrationType()}
                />
            }

        </div>
    </div>
    );
}
